(ns dashboard.views.prototypes.view
  (:require [dashboard.subs :as dashboard.subs]
            [dashboard.views.prototypes.question-clusters :as question-clusters]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]))

(def view-id-top :route.view/prototypes)
(def view-id-mode :route.view/prototypes-mode)

(defn menu-button
  [display-str value mode]
  [:a.button.button
   {:href (rfe/href view-id-mode {:mode (name value)})
    :class (when (= mode value) :is-info)}
   display-str])

(defn view []
  (let [props (-> @(rf/subscribe [::dashboard.subs/route])
                  :parameters
                  :path
                  (update :selected-person-id js/parseInt))
        mode (-> props :mode (or "question-clusters") keyword)]

    [:div.section.prototype-wraper
     [:div.level.menu
      [:div.level-left
       [:h1.title "Prototypes"]]
      ;; The thought here is that there will be more than 1???? Maybe? Hopefully!
      [:div.level-right.buttons
       [menu-button "Question Clusters" :question-clusters mode]]]
     (case mode
       :question-clusters
       [:f> question-clusters/View]

       [:<> "Not yet available"])]))
